import { Box } from '@mui/material';
import QRCode from 'qrcode.react';
import { useEffect, useState } from 'react';

interface Props {
  acctNo: string;
};

const QRCodeGenerator = (props: Props) => {
  const [qrValue, setQrValue] = useState<string>('');

  useEffect(() => {
    setQrValue(props.acctNo);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" p={4}>
      {qrValue && (
        <Box mt={4} display="flex" flexDirection="column" alignItems="center">
          <QRCode value={qrValue} size={256} />
        </Box>
      )}
    </Box>
  );
};

export default QRCodeGenerator;
